import React from 'react';
import { observer } from 'mobx-react-lite';
import { GapSizeType } from '../../../../../theme/type/gap-type';
import { cn, marginBottomClass, marginTopClass } from '../../../../../utils/tailwind';

type AgreeType = {
    children: React.ReactNode;
    marginTop?: GapSizeType;
    marginBottom?: GapSizeType;
};

export const Agree: React.FC<AgreeType> = observer(
    ({ children, marginTop = 'none', marginBottom = 'none' }: AgreeType) => {
        return (
            <div
                className={cn(
                    'flex flex-col items-stretch gap-[0.8rem] [&_a]:text-web-copy [&_a]:underline [&_a]:decoration-[1px] [&_a]:decoration-[#9b8d82]/60 [&_a]:underline-offset-[3px] [&_a]:transition-colors [&_a:hover]:text-[#4f433b] [&_a:hover]:decoration-[#72645a] [&_a:focus-visible]:text-[#4f433b] [&_a:focus-visible]:outline [&_a:focus-visible]:outline-2 [&_a:focus-visible]:outline-offset-2 [&_a:focus-visible]:outline-web-copy',
                    marginTopClass[marginTop],
                    marginBottomClass[marginBottom],
                )}
            >
                {children}
            </div>
        );
    },
);
